import React from 'react';
import Website from './Website';

const App = () => {
  return <Website />;
};

export default App;
